export const FETCH_TOURS_LIST = "FETCH_TOURS_LIST";
export const FETCH_TOURS_LIST_SUCCESS = "FETCH_TOURS_LIST_SUCCESS";
export const FETCH_TOURS_LIST_FAILED = "FETCH_TOURS_LIST_FAILED";

export const FETCH_TOURS_DETAILS = "FETCH_TOURS_DETAILS";
export const FETCH_TOURS_DETAILS_SUCCESS = "FETCH_TOURS_DETAILS_SUCCESS";
export const FETCH_TOURS_DETAILS_FAILED = "FETCH_TOURS_DETAILS_FAILED";

export const CREATE_TOUR = "CREATE_TOUR";
export const CREATE_TOUR_SUCCESS = "CREATE_TOUR_SUCCESS";
export const CREATE_TOUR_FAILED = "CREATE_TOUR_FAILED";

export const UPDATE_TOUR_INFO = "UPDATE_TOUR_INFO";
export const UPDATE_TOUR_INFO_SUCCESS = "UPDATE_TOUR_INFO_SUCCESS";
export const UPDATE_TOUR_INFO_FAILED = "UPDATE_TOUR_INFO_FAILED";

export const UPLOAD_URL = "UPLOAD_URL";
export const UPLOAD_URL_SUCCESS = "UPLOAD_URL_SUCCESS";
export const UPLOAD_URL_FAILED = "UPLOAD_URL_FAILED";

export const READ_URL = "READ_URL";
export const READ_URL_SUCCESS = "READ_URL_SUCCESS";
export const READ_URL_FAILED = "READ_URL_FAILED";

export const UPLOAD_BINARY_URL = "UPLOAD_BINARY_URL";
export const UPLOAD_BINARY_URL_SUCCESS = "UPLOAD_BINARY_URL_SUCCESS";
export const UPLOAD_BINARY_URL_FAILED = "UPLOAD_BINARY_URL_FAILED";

export const TOURS_UPDATE_DETAILS = "TOURS_UPDATE_DETAILS";
export const TOURS_UPDATE_DETAILS_SUCCESS = "TOURS_UPDATE_DETAILS_SUCCESS";
export const TOURS_UPDATE_DETAILS_FAILED = "TOURS_UPDATE_DETAILS_FAILED";
